<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <div>
                        <h3 class="texto2">La conexión ha sido interrumpida</h3>
                        <h5 class="texto1">Por favor, revisa tu conexión a internet e inténtalo más tarde.
                        </h5>
                    </div>
                    <br>
                    <img src="./assets/img/Error500.png" />
                </div>

                <div class="textoAbajo">
                    <img src="./assets/img/CancelacionSeguro.png" />
                    <br>
                    <div>
                        <h3 class="texto2">La conexión ha sido interrumpida</h3>
                        <h5 class="texto1">Por favor, revisa tu conexión a internet e inténtalo más tarde.
                        </h5>
                    </div>
                </div>

                <br><br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">
                        Intentar de nuevo
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>